import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import stateSelector from 'reduxModules/merchs/selectors'
import { merchsDispatchers as dispatchSelector } from 'reduxModules/merchs/dispatchers'
import { merchPropType } from "./Merch"
import template from './template.rt'
import './styles.css'

export class MerchList extends Component {
  static getLightBoxTheme() {
    return { close: { color: 'white' } }
  }

  componentDidMount() {
    this.props.loadMerchs()
  }

  render() {
    return template.call(this)
  }
}

MerchList.propTypes = {
  loadMerchs: PropTypes.func.isRequired,
  merchs: PropTypes.arrayOf(PropTypes.shape(merchPropType))
}

MerchList.defaultProps = {
  merchs: []
}

export default connect(
  stateSelector,
  dispatchSelector
)(MerchList)
